import { useAuthenticatedQueries, useAuthenticatedQuery } from "@l2r-front/l2r-auth"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"

export function useCampaignQuery(
    url,
    queryKey,
    queryParameters,
    config = { enabled: true },
    initialData = undefined,
) {
    const apiUrl = `campaign/${url}`
    const { enabled = true } = config
    const { selectedNetwork } = useNetworksStateContext()
    queryKey.push({ network: selectedNetwork?.slug })

    return useAuthenticatedQuery(
        apiUrl,
        queryKey,
        { ...queryParameters, project: selectedNetwork?.slug },
        {
            ...config,
            enabled: !!selectedNetwork?.slug && enabled,
        },
        initialData,
    )
}

export function useCampaignQueries(queriesData) {
    const { selectedNetwork } = useNetworksStateContext()

    const overridedQueriesData = queriesData.map(queryData => {
        queryData.queryKey.push({ network: selectedNetwork?.slug })
        const { enabled = true } = queryData.config
        const newConfig = {
            ...queryData.config,
            enabled: !!selectedNetwork?.slug && enabled,
        }

        return {
            url: `campaign/${queryData.url}`,
            queryKey: queryData.queryKey,
            queryParameters: { ...queryData.queryParameters, project: selectedNetwork?.slug },
            ...newConfig,
        }
    })

    return useAuthenticatedQueries(overridedQueriesData)
}